export default __webpack_public_path__ + "static/media/auth_img.9e3d7731.svg";